import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button
} from '@mui/material';

const ConstraintDeleteDialog = ({ open, constraint, onCancel, onConfirm, loading }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>刪除限制</DialogTitle>
    <DialogContent>
      <DialogContentText>
        確定要刪除限制「{constraint?.name}」嗎？此操作無法復原。
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>取消</Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
        刪除
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConstraintDeleteDialog;
